import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { IIcon } from '../../../shared/components/icon/icon.interface';
import { IconSizesEnum } from '../../../shared/components/icon/icons-sizes.enum';
import {
  ITrackingObject,
  TrackingScreenNamesEnum,
} from '../../../tracking/tracking.data';

export const DIALOG_TYPE = 'home-tasks-complete';

@Component({
  selector: 'app-home-tasks-complete-dialog',
  templateUrl: './home-tasks-complete-dialog.component.html',
  styleUrls: ['./home-tasks-complete-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeTasksCompleteDialogComponent implements OnInit {
  @Input() trackingObject: ITrackingObject;

  trackingScreenName: string;
  dialogType: string;
  successIcon: IIcon;

  constructor() {}

  ngOnInit() {
    this.trackingScreenName = TrackingScreenNamesEnum.task_listed_completion;
    this.dialogType = DIALOG_TYPE;
    this.successIcon = {
      name: 'tasks-completed',
      size: IconSizesEnum.custom,
    };
  }
}
